import { createFileRoute } from "@tanstack/react-router";
import { KeywordServiceLanding } from "@/components/KeywordServiceLanding";
import { keywordServiceHead } from "@/lib/keywordServicePages";
import { getTownMarketingPage } from "@/lib/townMarketingPages";

const PAGE = getTownMarketingPage("larkspur");

export const Route = createFileRoute("/marketing-larkspur")({
  head: () => keywordServiceHead(PAGE),
  component: () => <KeywordServiceLanding page={PAGE} />,
});
